var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartUtilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 31,
    viewBox: "0 0 82 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84001 12.08C9.04001 12.08 10.512 10.432 10.544 8.8C10.592 6.752 9.16801 5.648 5.93601 5.216C3.45601 4.88 3.58401 4.176 3.60001 3.888C3.66401 3.024 4.88001 2.896 5.61601 2.896C6.51201 2.912 7.68001 3.104 7.79201 4.192H10.112C10 2.096 8.35201 0.736001 5.68001 0.720001C3.07201 0.720001 1.36001 1.92 1.21601 3.856C0.992014 6.784 4.46401 7.28 5.60001 7.44C7.05601 7.648 7.66401 7.936 7.92001 8.16C8.11201 8.32 8.20801 8.544 8.20801 8.8C8.20801 9.84 6.54401 9.888 5.84001 9.888C3.93601 9.888 3.36001 9.008 3.21601 8.592H0.752014C0.928014 11.152 3.63201 12.08 5.84001 12.08Z",
    fill: "#28293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0089 12V0.800001H22.9129L19.0089 8.432L15.1049 0.800001H13.0089V12H15.2489V6.08L18.4009 12H19.6169L22.7689 6.08V12H25.0089Z",
    fill: "#28293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7981 12H29.0861L30.2061 9.568H35.4221L36.5421 12H38.8141L33.5821 0.800001H32.0461L26.7981 12ZM32.8141 3.904L34.5261 7.616H31.1021L32.8141 3.904Z",
    fill: "#28293D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.458 0.800001V12H42.698V8.192H45.002L47.722 12H50.346L47.402 7.84C48.762 7.312 49.546 6.128 49.546 4.496C49.546 1.28 46.826 0.800001 45.194 0.800001H40.458ZM45.146 2.896C46.922 2.896 47.29 3.536 47.29 4.496C47.29 5.472 46.922 6.112 45.146 6.112H42.698V2.896H45.146Z",
    fill: "#28293D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9146 2.88V12H57.1546V2.88H60.8186V0.800001H51.2506V2.88H54.9146Z",
    fill: "#28293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24801 24.608C1.24801 28.24 2.88001 30.08 6.08001 30.08C9.28001 30.08 10.912 28.24 10.912 24.608L10.928 18.8H8.67202L8.65601 24.512C8.65601 27.072 7.98401 27.984 6.08001 27.984C4.17601 27.984 3.50401 27.072 3.50401 24.512L3.52001 18.8H1.26401L1.24801 24.608Z",
    fill: "#28293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2359 20.88V30H18.4759V20.88H22.1399V18.8H12.5719V20.88H16.2359Z",
    fill: "#28293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5303 30V18.8H24.2903V30H26.5303Z",
    fill: "#28293D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9446 30V27.92H32.0886V18.8H29.8486V30H37.9446Z",
    fill: "#28293D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2328 30V18.8H39.9928V30H42.2328Z",
    fill: "#28293D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0471 20.88V30H50.2871V20.88H53.9511V18.8H44.3831V20.88H48.0471Z",
    fill: "#28293D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3415 30V18.8H56.1015V30H58.3415Z",
    fill: "#28293D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6599 30H70.0599V27.92H63.8999V25.44H69.6279V23.36H63.8999V20.88H69.8519V18.8H61.6599V30Z",
    fill: "#28293D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7125 30.08C79.9125 30.08 81.3845 28.432 81.4165 26.8C81.4645 24.752 80.0405 23.648 76.8085 23.216C74.3285 22.88 74.4565 22.176 74.4725 21.888C74.5365 21.024 75.7525 20.896 76.4885 20.896C77.3845 20.912 78.5525 21.104 78.6645 22.192H80.9845C80.8725 20.096 79.2245 18.736 76.5525 18.72C73.9445 18.72 72.2325 19.92 72.0885 21.856C71.8645 24.784 75.3365 25.28 76.4725 25.44C77.9285 25.648 78.5365 25.936 78.7925 26.16C78.9845 26.32 79.0805 26.544 79.0805 26.8C79.0805 27.84 77.4165 27.888 76.7125 27.888C74.8085 27.888 74.2325 27.008 74.0885 26.592H71.6245C71.8005 29.152 74.5045 30.08 76.7125 30.08Z",
    fill: "#28293D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartUtilities);
export default __webpack_public_path__ + "static/media/SmartUtilities.2cf9fa577ebd313f0c8b5a40d14c27ce.svg";
export { ForwardRef as ReactComponent };